export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/util/eventConsts.js
// module id = kJ17
// module chunks = 1